var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.918 4.03337C26.2583 3.38873 25.475 2.87736 24.6129 2.52847C23.7507 2.17958 22.8267 2 21.8934 2C20.9602 2 20.0361 2.17958 19.174 2.52847C18.3119 2.87736 17.5286 3.38873 16.8688 4.03337L15.4997 5.37059L14.1305 4.03337C12.7979 2.73186 10.9905 2.00067 9.10587 2.00067C7.22128 2.00067 5.41387 2.73186 4.08126 4.03337C2.74865 5.33488 2 7.1001 2 8.94072C2 10.7813 2.74865 12.5466 4.08126 13.8481L5.45043 15.1853L15.4997 25L25.5489 15.1853L26.918 13.8481C27.5781 13.2037 28.1017 12.4387 28.4589 11.5967C28.8161 10.7547 29 9.85216 29 8.94072C29 8.02928 28.8161 7.12677 28.4589 6.28475C28.1017 5.44273 27.5781 4.6777 26.918 4.03337V4.03337Z",
    stroke: "#6A4029",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.30f15c8ef024f2e4a748c30efb3cc180.svg";
export { ForwardRef as ReactComponent };